var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_92_1349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 36C16.5 24.7643 16.5 19.1465 19.1965 15.1109C20.3638 13.3638 21.8638 11.8638 23.6109 10.6965C27.6465 8 33.2643 8 44.5 8C55.7357 8 61.3535 8 65.3891 10.6965C67.1362 11.8638 68.6362 13.3638 69.8035 15.1109C72.5 19.1465 72.5 24.7643 72.5 36C72.5 47.2357 72.5 52.8535 69.8035 56.8891C68.6362 58.6362 67.1362 60.1362 65.3891 61.3035C61.3535 64 55.7357 64 44.5 64C33.2643 64 27.6465 64 23.6109 61.3035C21.8638 60.1362 20.3638 58.6362 19.1965 56.8891C16.5 52.8535 16.5 47.2357 16.5 36Z",
    fill: "url(#paint0_linear_92_1349)",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1804 39.5002L47.1814 36L41.1804 32.5V39.5002Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5708 44.2947V28.7073H49.7009C49.1831 28.7073 48.7634 28.2876 48.7634 27.7698V20H34.1875C32.6367 20 31.375 21.2617 31.375 22.8125V44.2947H57.5708ZM49.0168 34.8999C49.0442 34.9158 49.0706 34.9331 49.0959 34.9517C49.4419 35.2034 49.6404 35.5854 49.6404 35.9998C49.6404 36.4143 49.4421 36.7964 49.0962 37.0483C49.0706 37.0669 49.0442 37.0842 49.0168 37.1001L41.5161 41.4749C41.2759 41.6345 40.9927 41.7158 40.7078 41.7158C40.4783 41.7158 40.248 41.6631 40.0378 41.5562C39.5862 41.3262 39.3054 40.8801 39.3054 40.3923V31.6077C39.3054 31.1199 39.5859 30.6741 40.0378 30.4441C40.509 30.2041 41.0825 30.2373 41.5161 30.5251L49.0168 34.8999Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.6384 26.8323H57.0178L50.6384 20.5452V26.8323Z",
    fill: "#D3A837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.375 46.1697V49.1875C31.375 50.7383 32.6367 52 34.1875 52H54.7585C56.3093 52 57.571 50.7383 57.571 49.1875V46.1697H31.375Z",
    fill: "#D3A837"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_92_1349",
    x: 0.5,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.827451 0 0 0 0 0.658824 0 0 0 0 0.215686 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_92_1349"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_92_1349",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_92_1349",
    x1: 44.5,
    y1: 8,
    x2: 44.5,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFE0B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE88"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.27b98d21b8419218e03cf893d3023c01.svg";
export { ForwardRef as ReactComponent };